import { CSSProperties, Dispatch, Ref, SetStateAction } from "react";

import useMantineMediaQueries from "@hl/base-components/lib/hooks/useMantineMediaQueries";
import FilterSidebar from "@hl/shared-features/lib/features/marketplace/components/FilterSidebar";
import { Box, Checkbox, Divider, Flex, Switch, Text } from "@mantine/core";
import { Property } from "csstype";

export type FilterSidebarCollectedProps = {
  ref?: Ref<HTMLDivElement>;
  filteringOptions: { label: string; value: string }[];
  showFilters: boolean;
  closeFilters: () => void;
  statusFilter?: string;
  setStatusFilter: Dispatch<SetStateAction<string | undefined>>;
  style?: CSSProperties;
  scrollContainerConfig?: {
    height: Property.Height;
    mobileHeight: Property.Height;
  };
};

const FilterSidebarCollected = ({
  ref,
  filteringOptions,
  showFilters,
  closeFilters,
  statusFilter,
  setStatusFilter,
  style,
  scrollContainerConfig = {
    mobileHeight: "calc(100vh - 152px)",
    height: "calc(100vh - 96px - var(--mantine-header-height, 0px))",
  },
}: FilterSidebarCollectedProps) => {
  const isFiltering = !!statusFilter;
  const { isSmall } = useMantineMediaQueries();

  return (
    <FilterSidebar
      scrollContainerConfig={scrollContainerConfig}
      isFiltering={isFiltering}
      showFilters={showFilters}
      handleClearFilters={() => setStatusFilter(undefined)}
      closeFilters={closeFilters}
      title="Filter Collected"
      ref={ref}
      style={style}
      stickyHeaderAdjustment={isSmall ? -95 : -45}
    >
      <Text weight={500} size={18} mb={4}>
        Status
      </Text>
      <Box pt={10} w="100%">
        <Flex justify="space-between" mb={5}>
          <Text size="sm">All items</Text>
          <Switch
            checked={!statusFilter}
            onChange={() => setStatusFilter(undefined)}
          />
        </Flex>
        <Divider />
      </Box>
      {filteringOptions.map(({ value, label }) => (
        <Box key={value} pt={10}>
          <Checkbox
            labelPosition="left"
            label={label}
            checked={statusFilter === value}
            styles={{
              body: { width: "100%" },
              labelWrapper: {
                width: "100%",
                maxWidth: "calc(100% - 20px)",
              },
              label: {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
            }}
            mb={10}
            onChange={(e) =>
              setStatusFilter(e.currentTarget.checked ? value : undefined)
            }
          />
          <Divider />
        </Box>
      ))}
    </FilterSidebar>
  );
};

export default FilterSidebarCollected;
